import { SmallHeadline, TinyHeadline } from '@minted/fancyclothes';
import React, { memo } from 'react';
import isEqual from 'lodash/isEqual';
import {
  AttendantDetails, Configuration, Section,
} from '../../../resources/modelTypes';
import { BLANK_SLATE_DOCUMENT } from '../../../core/constants';
import { DisplayPhoto } from '../DisplayPhoto';
import { RichTextContent } from '../../../content/components';

import { css } from '@emotion/react';
import { styleUtils, theme } from '@minted/minted-components';
import { selectors } from '../../cypressSelectors';

const grid = (layout) => css`
  ${theme.media.greaterThan(theme.breakpoints.medium)(`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: ${styleUtils.rem(70)};
    & > * {
      width: ${layout === 'multi' ? 'calc(5/12 * 100%)' : '100%'};
    };
  `)}
`;

export type AttendantSection = Section & {
  sectionDetails: AttendantDetails;
};

export type DisplayAttendantSectionProps = {
  configuration: Configuration
  sections: AttendantSection[],
};

const DisplayAttendantSection = ({
  configuration,
  sections,
}: DisplayAttendantSectionProps) => (
  <div css={grid(configuration.pageLayout)}>
    {
      sections.map((section) => (
        <div
          data-cy={`${selectors.website_displaySection}_attendant`}
          key={section.id}
        >
          {
            section.photo && (
              <DisplayPhoto
                configuration={configuration}
                section={section}
              />
            )
          }
          <div data-cy="subheading">
            <SmallHeadline>
              {section.sectionDetails.name}
            </SmallHeadline>
          </div>
          <div
            data-cy="body"
          >
            <TinyHeadline>
              {section.sectionDetails.title}
            </TinyHeadline>
            {
              section.sectionDetails.content && !isEqual(section.sectionDetails.content, BLANK_SLATE_DOCUMENT) && (
                <div>
                  <RichTextContent value={section.sectionDetails.content} />
                </div>
              )
            }
          </div>
        </div>
      ))
    }

  </div>

);

const MemoizedDisplayAttendantSection = memo(DisplayAttendantSection);

export { MemoizedDisplayAttendantSection as DisplayAttendantSection };
